import { IEntityContentJson } from '@beefree.io/sdk/dist/types/bee';

import { IBasePostgresModel } from '@/bundles/App/interfaces/IBasePostgresModel';
import { Nullable } from '@/utils/types';
import { PropertyTypeEnum } from '@/bundles/Property/interfaces/PropertyType';
import { TemplateTransactionType } from '@/bundles/MarketingTemplate/types/index';

export enum MarketingTemplateTypeEnum {
  eblast = 'eblast',
  press_release = 'press_release',
  case_study = 'case_study',
  news = 'news',
  website = 'website',
  newsletter = 'newsletter',
  whitepaper = 'whitepaper',
  email = 'email'
}

export interface IMarketingTemplate extends IBasePostgresModel {
  enterprise: number;
  type: MarketingTemplateTypeEnum;
  is_draft: boolean;
  name: string;
  description: Nullable<string>;
  account_ids: number[];
  active: boolean;
  public: boolean;
  path: string;
  path_html: string;
  tile: string;
  is_system: boolean;
  is_editable: boolean;
  number?: number;
  property_types: PropertyTypeEnum[];
  use_types: string[];
  specializations: string[];
  transaction_types: TemplateTransactionType[];
}

export type IGetMarketingTemplatesParams = any; // TODO sychdo: add proper type

export interface ITemplateFormData {
  type: MarketingTemplateTypeEnum;
  name: string;
  description: Nullable<string>;
  is_draft: boolean;
  public: boolean;
  property_types?: PropertyTypeEnum[];
  transaction_types?: TemplateTransactionType[];
  use_types?: string[];
  specializations?: string[];
  html?: string; // DO link to HTML
}

export interface IPostMarketingTemplateParams extends ITemplateFormData {
  template: IEntityContentJson;
  html: string;
};

export interface IPostMarketingImportHtmlTemplateParams extends ITemplateFormData {
  template: IEntityContentJson;
  formData: FormData;
};

export interface IEditTemplateContentParams {
  id: number | string;
  template: IEntityContentJson;
  html: string;
};

export interface IEditTemplateInfoParams extends ITemplateFormData {
  id: number | string;
};

export interface IMarketingSortItem {
  field: string;
  desc: boolean;
}

export interface IPressReleaseEditFormEntry {
  title: string;
  subtitle: string;
  content: string;
  template_id: number;
  key: string;
}
